const CropIcon = () => {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="var(--secondary-color)" />
			<circle cx="7" cy="8.82797" r="1" transform="rotate(-135 7 8.82797)" fill="var(--secondary-color)" />
			<circle
				cx="4.17188"
				cy="5.99985"
				r="1"
				transform="rotate(-135 4.17188 5.99985)"
				fill="var(--secondary-color)"
			/>
			<circle
				cx="9.82812"
				cy="5.99985"
				r="1"
				transform="rotate(-135 9.82812 5.99985)"
				fill="var(--secondary-color)"
			/>
		</svg>
	);
};

export default CropIcon;
